import React, { useState, useEffect, createContext } from "react";
import { useTranslation, Trans } from "react-i18next";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import Enquiry from "./pages/enquiry/Enquiry";
import { useNavigate } from "react-router-dom";
import { getWorkshopInfo } from "./api/apiManagement";
import { Helmet } from "react-helmet";

export const GlobalContext = createContext();

function App() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  document.title = t("global:title");
  const queryParameters = new URLSearchParams(window.location.search);
  const lang = queryParameters.get("lang");
  const code = queryParameters.get("code");
  const [width, setWidth] = useState(window.innerWidth);
  const [isLoading, setIsLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [haveCode, setHaveCode] = useState("");
  const [canFetchData, setCanFetchData] = useState(true);
  const [submitData, setSubmitData] = useState({});
  const [infoData, setInfoData] = useState([]);

  const expire_date = JSON.parse(localStorage.getItem("user_data"))
    ?.expire_date;

  const dataValue = {
    isLoading,
    setIsLoading,
    canFetchData,
    setCanFetchData,
    isLogin,
    setIsLogin,
    submitData,
    setSubmitData,
    infoData,
    setInfoData,
    haveCode,
  };

  useEffect(() => {
    if (new Date().getTime() < new Date(expire_date).getTime()) {
      setIsLogin(true);
    }
  }, []);

  useEffect(() => {
    if (lang === null || lang === "") {
      i18n.changeLanguage(localStorage.getItem("lang"));
    }

    if (lang === "hk_en") {
      i18n.changeLanguage("hk_en");
    }
    if (lang === "hk") {
      i18n.changeLanguage("hk");
    }
  }, []);

  useEffect(() => {
    console.log("can fetch data");
    setCanFetchData(true);
    console.log(i18n);
  }, [navigate, i18n.language]);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
    };
    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    let data = { code: code };
    setHaveCode(code);
    if (canFetchData) {
      getWorkshopInfo(data)
        .then((res) => {
          const statsCode = res.data.StatusCode;

          if (statsCode === 500) return;
          if (statsCode === 200) setInfoData(res.data.Data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setCanFetchData(false);
  }, [canFetchData, isLogin]);

  useEffect(() => {
    console.log(infoData);
  }, [infoData]);
  return (
    <GlobalContext.Provider value={dataValue}>
      <div className="App">
        {isLoading ? <Loading /> : <></>}
        <Header />
        <Routes>
          <Route index path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/enquiry" element={<Enquiry />} />
        </Routes>

        <Footer />
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
